var map = {
	"./bg_error.png": 4181,
	"./logo_rg.png": 1342,
	"./logo_rg_white_signet.png": 6936,
	"./logo_signet.svg": 5298,
	"./logo_variant_2.svg": 3493,
	"./logo_vplayer.png": 3079,
	"./rg_error_logo.png": 5108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;